import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Injectable, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal, NgbCalendar, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerConfig, NgbDatepickerModule, NgbDateStruct, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomLandingModule } from '../../custom-landing.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18nModule, TranslationService } from '@spartacus/core';
import { ToastrService } from 'ngx-toastr';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { FileUploader, FileUploadModule } from 'ng2-file-upload';
import { SharedModule } from 'src/app/shared/shared.module';
import { Router } from '@angular/router';
import { ShipmentInspectionConfirmationComponent } from '../shipment-inspection-confirmation/shipment-inspection-confirmation.component';
import { CustomProductsService } from '../../custom-products/custom-products.service';
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? ('0' + date.day).slice(-2) + this.DELIMITER + ('0' + date.month).slice(-2) + this.DELIMITER + date.year : '';
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? ('0' + date.day).slice(-2) + this.DELIMITER + ('0' + date.month).slice(-2) + this.DELIMITER + date.year : '';
  }
}
@Component({
  selector: 'app-shipment-inspection-update',
  imports: [CommonModule, NgbDatepickerModule, FormsModule, ReactiveFormsModule, NgbModule, CustomLandingModule, NgSelectModule, I18nModule, FileUploadModule, SharedModule],
  templateUrl: './shipment-inspection-update.component.html',
  styleUrl: './shipment-inspection-update.component.scss',
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ]
})
export class ShipmentInspectionUpdateComponent implements OnInit {
  @Input() updateInspectionData;
  @Input() activeTab;
  @Input() searchText;
  @Input() formValues: any;
  @Input() attachmentsList: any[] = [];
  @Input() filestoPushforcall: any[] = [];
  @Input() requestParams: any;
  updateForm: UntypedFormGroup;
  form: UntypedFormGroup;
  displayMonths = 2;
  navigation = 'arrows';
  showWeekNumbers = false;
  outsideDays = 'hidden';
  fileSize: any;
  fileName: any;
  filesLength: any;
  filesDetail: any;
  formData: any;
  inspectionCompleted: any;
  docValues: { id: string; Name: string; }[];
  uploaddoc: boolean = false;
  fileArray = [];
  shipmentinspectiondata: any = [];
  filesTopushForCall = [];
  base64: any;
  enableLoader: boolean = false;
  startLoader: boolean = false;
  selected = false;
  isHidden = false;
  arrayBuffer!: any;
  uploadErr: boolean = false;
  signatures = {
    JVBERi0: "application/pdf",
    R0lGODdh: "image/gif",
    R0lGODlh: "image/gif",
    iVBORw0KGgo: "image/png",
    "/9j/": "image/jpg"
  };
  startDate: any;
  endDate: any;
  invalidAnyone: boolean = false;
  invalidAll: boolean = false;

  @Output() fileadded = new EventEmitter<string>();
  @Output() passActiveTab: EventEmitter<any> = new EventEmitter();
  notValidate: boolean = false;
  azureFailure: boolean = false;
  azureSuccess: boolean = false;
  azureStatus: string = '';
  @Input() validateAPIMsgAvailable: boolean = false;
  revalidateClicked: boolean = false;
  @Input() azureValidationRemark: any;

  isValidationInProgress: boolean;
  showNextButton: boolean = false;
  shipmentListDetail: any;
  showReload: boolean = false;
  showReValidate: boolean = true;
  constructor(public ActiveModal: NgbActiveModal,
    private toastrService: ToastrService,
    private translationService: TranslationService,
    private config: NgbDatepickerConfig,
    public formatter: NgbDateParserFormatter,
    private dateAdapter: NgbDateAdapter<string>,
    private calendar: NgbCalendar,
    private formbuilder: UntypedFormBuilder,
    public modalService: NgbModal,
    private customprofile: CustomProfileService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private customProductService: CustomProductsService,
  ) {

  }
  ngOnInit(): void {
    console.log(this.updateInspectionData);
    this.azureStatus = (this.updateInspectionData?.azureStatus || '') as 'SUCCESS' | 'FAILURE' | 'IN_PROGRESS';

    this.docValues = [
      { id: 'yes', Name: 'YES' },
      { id: 'no', Name: 'NO' }];

    this.updateForm = this.formbuilder.group({
      draftSurveyQty: [this.updateInspectionData.draftSurveyQty ? this.updateInspectionData.draftSurveyQty : null],
      inspectionCompleted: [null],
      surveyStartDate: [''],
      surveyEndDate: [''],
    });
    if (this.activeTab === 'Completed' || this.azureStatus.toLowerCase() === 'success') {
      this.updateForm.get('draftSurveyQty')?.disable();
      this.updateForm.get('stockAdjustment')?.disable();
      this.updateForm.get('surveyStartDate')?.disable();
      this.updateForm.get('surveyEndDate')?.disable();
      this.updateForm.get('inspectionCompleted')?.disable();
    }
    if (this.updateInspectionData?.surveyStartDate) {
      let formatstartdate = this.updateInspectionData.surveyStartDate.replace(/\//g, '-');
      this.updateForm.controls['surveyStartDate'].setValue(formatstartdate);
    }
    if (this.updateInspectionData?.surveyEndDate) {
      let formatenddate = this.updateInspectionData.surveyEndDate.replace(/\//g, '-');
      this.updateForm.controls['surveyEndDate'].setValue(formatenddate);
    }
    if (this.updateInspectionData?.inspectionCompleted == true && this.updateInspectionData.shipmentInspectionStatusCode == 'COMPLETED') {
      this.inspectionCompleted = 'yes';
      this.uploaddoc = true;
      this.updateForm.controls['inspectionCompleted'].setValue(this.inspectionCompleted);
    } else {
      this.inspectionCompleted = 'no';
      this.updateForm.controls['inspectionCompleted'].setValue(this.inspectionCompleted);
      this.uploaddoc = false;
    }
    if (this.formValues) {
      this.updateForm.patchValue({
        draftSurveyQty: this.formValues?.draftSurveyQty ?? null,
        surveyStartDate: this.formValues?.surveyStartDate ? this.formValues.surveyStartDate.replace(/\//g, '-') : '',
        surveyEndDate: this.formValues?.surveyEndDate ? this.formValues.surveyEndDate.replace(/\//g, '-') : '',
        inspectionCompleted: this.formValues?.inspectionCompleted ?? this.inspectionCompleted,
        stockAdjustment: !!this.formValues?.stockAdjustment,
      });

      if (!!this.formValues?.stockAdjustment) {
        const fields = ['draftSurveyQty', 'surveyStartDate', 'surveyEndDate', 'inspectionCompleted'];
        fields.forEach(field => this.updateForm.get(field)?.disable());
      }

      if (this.formValues?.inspectionCompleted) {
        this.inspectionCompleted = this.formValues.inspectionCompleted;
        this.uploaddoc = this.inspectionCompleted === 'yes';
      }
    }
     this.checkValiationTimeout();
    if (this.attachmentsList?.length) {
      this.fileArray = [...this.attachmentsList];
      this.filesTopushForCall = [...(this.filestoPushforcall || [])];
      this.filesLength = this.fileArray.length;
      this.enableLoader = false;
      return;
    }

    if (this.updateInspectionData?.attachments?.length >= 1) {
      this.updateInspectionData.attachments.forEach(e => {
        let mimeType = this.detectMimeType(e.base64);
        //let mimeType = e.mime; // written for testing purpose while data is coming from local json file
        console.log(mimeType, "mimeType")
        this.fileArray.push({
          fileInBase64: e.base64,
          mime: mimeType,
          name: e.documentName,
          size: e.size,
          downloadURL: e.downloadURL
        })
      })
      this.enableLoader = false;
    } else {
      this.fileArray = [];
      this.enableLoader = false;
    }  
  }
checkValiationTimeout(){
    if (this.updateInspectionData.azureStatus.toLowerCase() === 'in_progress') {
      this.showReload = true;
      if (this.updateInspectionData.triggerTimeStamp) {
        const currentTime = new Date();
        const validationTime = new Date(this.updateInspectionData.triggerTimeStamp);
        const timeDifference = Math.abs(currentTime.getTime() - validationTime.getTime());
        const minutesDifference = timeDifference / 1000;
        console.log('Minutes difference since validation started:', minutesDifference, timeDifference, validationTime);
        if (minutesDifference > this.updateInspectionData.timeoutSeconds) {
          this.showReValidate = true;
        } else {
          this.showReValidate = false;
        }
      }
    }
  }
  detectMimeType(b64) {
    for (var s in this.signatures) {
      if (b64.indexOf(s) === 0) {
        return this.signatures[s];
      }
    }
  }
  public uploader: FileUploader = new FileUploader({
    url: ``,
    disableMultipart: false,
    autoUpload: true,
    method: 'post',
    itemAlias: 'attachment',
    allowedFileType: ['xls', 'xlsx', 'pdf', 'jpeg', 'png'],
    maxFileSize: 10485760,
  });
  close(status) {
    this.ActiveModal.close(this.activeTab);

  }
  selectInspection(flag) {
    if (flag == 'no') {
      this.uploaddoc = false;
      this.inspectionCompleted = 'no';
      this.updateForm.controls['inspectionCompleted'].setValue(this.inspectionCompleted);
    } else {
      this.uploaddoc = true;
      this.inspectionCompleted = 'yes';
      this.updateForm.controls['inspectionCompleted'].setValue(this.inspectionCompleted);
    }
  }
  removeWarning() {
    this.uploadErr = false;
  }
  onDragOver(event) {
    event.preventDefault();
  }

  onDropSuccess(event) {
    event.preventDefault();

    this.onFileChange(event.dataTransfer.files);
  }

  onChange(event) {
    this.startLoader = true;
    this.onFileChange(event)
  }


  private onFileChange(event) {
    //console.log('files....',files);
    this.uploadErr = false;
    this.filesLength = event.length;
    console.log(this.filesLength)
    const file: File = event[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {

      this.base64 = reader.result
      const words = this.base64.split(',')[1]
      const filedata = {
        fileInBase64: words,
        mime: file.type,
        name: file.name,
        size: file.size.toString(),
        donwloadURL: words
      }
      let fileformatmessage = '';
      let errorMessage = '';
      let fileexceedmsg = ''
      this.translationService.translate('shipment.pdf').subscribe(res => {
        fileexceedmsg = res;
      })
      this.translationService.translate('shipment.fileformatmsg').subscribe(res => {
        fileformatmessage = res;
      })
      if ((filedata.mime == 'application/pdf' || filedata.mime == 'image/jpeg' || filedata.mime == 'image/png'
        || filedata.mime == 'application/vnd.ms-excel' || filedata.mime == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') && file.size < 10485760) {
        this.fileArray.push(filedata);
        this.filesTopushForCall.push(filedata);
        this.startLoader = false;

      }
      else if (filedata.mime != 'application/jpeg' && filedata.mime != 'image/pdf' && filedata.mime != 'image/png' && filedata.mime != 'application/vnd.ms-excel' && filedata.mime != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.toastrService.show(fileformatmessage);
        this.startLoader = false;
      }
      else if (file.size > 10485760) {

        this.toastrService.show(fileexceedmsg);
        this.startLoader = false;
      }

    }
  }
  deleteImage() {
    this.fileName = null;
    this.filesDetail = null;
    this.filesLength = 0;
  }
  removeFile(i: any) {
    console.log(i, this.fileArray)
    this.uploader.queue.splice(i, 1);
    this.fileArray.splice(i, 1);

    if (this.updateInspectionData?.attachments.length > 0) {
      this.startLoader = true;
      let data = {
        nominationKey: this.updateInspectionData.nominationKey,
        nominationKeyItem: this.updateInspectionData.nominationItemNumber,
        documentId: this.updateInspectionData.attachments[i].documentId
      }
      this.customprofile.removeInspdocument(this.updateInspectionData.nominationNumber, data).subscribe((res) => {
        if (res) {
          this.startLoader = false;
          this.toastrService.show(res.success);
        } else {
          this.toastrService.show(res.error);
        }
      },
        err => {
          this.enableLoader = false;
          console.log("err", err);
          this.toastrService.show("Sorry something went wrong, please try again!");
        })
    }
  }
  onDateSelect($event) {
    this.startDate = $event;
  }
  onEndDateSelect($event) {
    this.endDate = $event;
  }


  resetError() {
    this.invalidAnyone = false;
    this.invalidAll = false;
  }
  private formatDates(startDate: string, endDate: string): { start: string; end: string } {
    return {
      start: startDate.replace(/\-/g, '/'),
      end: endDate.replace(/\-/g, '/')
    };
  }

  private buildSaveObject(formData: any, dates: { start: string; end: string }): any {
    const inspectionCompleted =
      formData?.inspectionCompleted === true || formData?.inspectionCompleted === 'yes';

    return {
      "nominationNumber": this.updateInspectionData.nominationNumber,
      "nominationItemNumber": this.updateInspectionData.nominationItemNumber,
      "nominationKey": this.updateInspectionData.nominationKey,
      "inspectionCompleted": inspectionCompleted,
      // "attachments": this.fileArray,
      "draftSurveyQty": formData?.draftSurveyQty,
      "surveyEndDate": dates.end,
      "surveyStartDate": dates.start,
    };
  }

  submitUpdate(form) {
    console.log(form.value);
    this.formData = form.value;
    const dates = this.formatDates(this.formData.surveyStartDate, this.formData.surveyEndDate);
    if ((this.updateForm.controls['inspectionCompleted'].value === 'no') && ((this.updateForm.controls['draftSurveyQty'].value != null && this.updateForm.controls['draftSurveyQty'].value != '') || this.updateForm.controls['surveyStartDate'].value != '' || this.updateForm.controls['surveyEndDate'].value != '')) {
      //inspection completed= NO && anyone selected    
      //save successfully
      let SaveObject = {
        "nominationNumber": this.updateInspectionData.nominationNumber,
        "nominationItemNumber": this.updateInspectionData.nominationItemNumber,
        "nominationKey": this.updateInspectionData.nominationKey,
        // "attachments": this.fileArray,
        "draftSurveyQty": this.formData.draftSurveyQty,
        "surveyEndDate": dates.end,
        "surveyStartDate": dates.start,
      }
      this.callForSavingInfo(SaveObject);
    } else if ((this.updateForm.controls['draftSurveyQty'].value == null || this.updateForm.controls['surveyStartDate'].value == '' || this.updateForm.controls['surveyEndDate'].value == '') && (this.updateForm.controls['inspectionCompleted'].value === 'yes')) {
      //inspection completed =YES && anyone null    
      //fillup all above data
      this.invalidAll = true;
      this.invalidAnyone = false;

    } else if ((this.updateForm.controls['draftSurveyQty'].value != null && this.updateForm.controls['surveyStartDate'].value != '' && this.updateForm.controls['surveyEndDate'].value != '') && (this.updateForm.controls['inspectionCompleted'].value === 'yes')) {
      //inspection completed= YES && all selected    
      //check for file upload and save
      this.formData.inspectionCompleted = true;
      let SaveObject = this.buildSaveObject(this.formData, dates);
      console.log(this.fileArray)
      if (this.fileArray.length === 0) {
        this.uploadErr = true;
      } else {
        this.uploadErr = false;
        this.callForSavingInfo(SaveObject);
      }
    } else if ((this.updateForm.controls['inspectionCompleted'].value === 'no') && (this.updateForm.controls['draftSurveyQty'].value == null || this.updateForm.controls['surveyStartDate'].value == '' || this.updateForm.controls['surveyEndDate'].value == '')) {
      //inspection completed =NO && all empty    
      //fillup all above data
      this.invalidAnyone = true;
      this.invalidAll = false;

    }
  }
  callForSavingInfo(SaveObject: any, isValidateSave: boolean = false) {
    this.enableLoader = true;
    if (this.filesTopushForCall.length > 0) {
      const attachmentdata = {
        nominationKey: this.updateInspectionData.nominationKey,
        nominationKeyItem: this.updateInspectionData.nominationItemNumber,
        files: this.filesTopushForCall
      };
      this.customprofile.uploadInspdocument(this.updateInspectionData.nominationNumber, attachmentdata).subscribe(
        (res) => {
          if (res.success) {
            this.enableLoader = false;
            this.toastrService.show(res.success);
            this.executeSaveShipmentUpdate(SaveObject, isValidateSave);
          } else {
            this.enableLoader = false;
            this.toastrService.show(res.error);
          }
        },
        () => {
          this.enableLoader = false;
          this.toastrService.show('Sorry something went wrong, please try again!');
        }
      );
    } else if (this.updateInspectionData.attachments?.length > 0 && this.filestoPushforcall.length == 0) {
      this.executeSaveShipmentUpdate(SaveObject, isValidateSave);
    }
  }

  private executeSaveShipmentUpdate(SaveObject: any, isValidateSave: boolean): void {
    let toastshown = false;
    this.customprofile.saveShipmentInspectionUpdate(SaveObject, isValidateSave).subscribe(
      (response: any) => {
        if (response) {
          this.enableLoader = false;
          if (isValidateSave) {
            this.validateUpdate('DRAFTSURVEY_UC7');
          }
          console.log(response);
          if (!isValidateSave) {
            if (response.shipmentInspectionStatusCode === 'COMPLETED') {
              this.passActiveTab.emit('Completed');
            } else {
              this.passActiveTab.emit('Active');
            }
            this.close('saved');
          }
        } else {
          this.enableLoader = false;
          this.translationService.translate('shipment.emptyerrormessage').subscribe(res => {
            if (!toastshown) {
              this.toastrService.show(res);
              toastshown = true;
            }
          });
        }
      },
      () => {
        this.enableLoader = false;
        this.translationService.translate('shipment.erroroccuredmessage').subscribe(res => {
          if (!toastshown) {
            this.toastrService.show(res);
            toastshown = true;
          }
        });
      }
    );
  }
  private hasAtLeastOneDocumentForValidation(): boolean {
    const totalSelectedFiles = this.fileArray?.length ?? 0;
    const existingFilesCount = this.updateInspectionData?.attachments?.length ?? 0;
    if (totalSelectedFiles === 0 && existingFilesCount == 0) {
      this.translationService.translate('batches.pleaseUploadAFile').subscribe(res => {
        this.toastrService.show(res);
      });   
     return false;   
    }
    else if (!this.isUpdateFormFilled) {
      this.toastrService.show('Please fill all required fields');
      return;
    }
    return true;
  }


  onNextClick(form): void {
    if (!this.hasAtLeastOneDocumentForValidation()) {
      return;
    }

    console.log('onNextClick Form values', form.value);
    const formData = form.getRawValue();
    const dates = this.formatDates(formData.surveyStartDate, formData.surveyEndDate);
    const SaveObject = this.buildSaveObject(formData, dates);

    // Pass the same SaveObject to confirmation component
    const modalRef = this.modalService.open(ShipmentInspectionConfirmationComponent, { centered: true, size: 'md' });
    modalRef.componentInstance.updateInspectionData = this.updateInspectionData;
    modalRef.componentInstance.formValues = formData;
    modalRef.componentInstance.activeTab = this.activeTab;
    modalRef.componentInstance.attachmentsList = this.fileArray;
    modalRef.componentInstance.filestoPushforcall = this.filesTopushForCall;
    modalRef.componentInstance.SaveObject = SaveObject;
    modalRef.componentInstance.inspectionCompleted = this.inspectionCompleted;
    modalRef.componentInstance.azureStatus = this.azureStatus;
    modalRef.componentInstance.azureValidationRemark = this.azureValidationRemark;
    modalRef.result.then((result) => {
      if (result === 'confirmed') {
        this.passActiveTab.emit('Completed'); // Emit the active tab to parent component to refresh the list based on current active tab
      }
    });
     this.ActiveModal.dismiss('next');
  }
  onValidateClick(): void {
    if (!this.hasAtLeastOneDocumentForValidation()) {
      return;
    }
    const formData = this.updateForm.getRawValue();
    const dates = this.formatDates(formData.surveyStartDate, formData.surveyEndDate);
    const saveObject = this.buildSaveObject(formData, dates);
    this.callForSavingInfo(saveObject, true);
    // this.validateUpdate('DRAFTSURVEY_UC7');
  }

  onRevalidateClick(): void {
    if (!this.hasAtLeastOneDocumentForValidation()) {
      return;
    }
    const formData = this.updateForm.getRawValue();
    const dates = this.formatDates(formData.surveyStartDate, formData.surveyEndDate);
    const saveObject = this.buildSaveObject(formData, dates);
    this.callForSavingInfo(saveObject, true);
    // this.validateUpdate('DRAFTSURVEY_UC7');
  }

  private validateUpdate(type: 'DRAFTSURVEY_UC7'): void {
    if (this.updateInspectionData.isStockAdjustmentSuccess) {
      return;
    }

    const validateRequest = {
      nomination: this.updateInspectionData?.nominationNumber,
      nominationKey: this.updateInspectionData?.nominationKey,
      nominationKeyItem: this.updateInspectionData?.nominationItemNumber,
    };

    if (
      !validateRequest.nomination ||
      !validateRequest.nominationKey ||
      !validateRequest.nominationKeyItem
    ) {
      this.toastrService.show('Unable to validate records. Missing nomination details.');
      return;
    }

    this.showNextButton = true;
    this.enableLoader = true;
    this.cd.detectChanges(); // Ensure UI updates before API call
    this.customprofile.validateRecordPickup(validateRequest, type).subscribe({
      next: (res) => {
        this.enableLoader = false;
        this.revalidateClicked = type === 'DRAFTSURVEY_UC7';
        this.getShipmentDetails();
      },
      error: () => {
        this.enableLoader = false;
        this.getShipmentDetails();
        this.toastrService.show('Validation failed.');
      }
    });
  }
  getShipmentDetails() {
    this.enableLoader = true;
    let toastshown = false;
    this.cd.detectChanges();
    // CommentsStart since user might have scrolled and pagination might have kicked in, resetting the search text and page number to get the updated details of the same nomination number
    this.searchText = this.updateInspectionData.nominationNumber;
    this.requestParams.currentPage = 0;
    // CommentsEnd

    this.customProductService.getShipmentInspectionListData(this.requestParams, this.searchText).subscribe((data) => {
      if (data) {
        this.enableLoader = false;
        this.shipmentListDetail = data;
        console.log(this.shipmentListDetail.shipments, "shipment list details after validation");
        if (this.shipmentListDetail.shipments && this.shipmentListDetail.shipments.length > 0) {
          this.updateInspectionData = this.shipmentListDetail.shipments.filter(item => { return item.formattedNominationNumber === this.updateInspectionData.formattedNominationNumber })?.[0]
          this.azureStatus = this.updateInspectionData.azureStatus;
          //this.azureStatus = 'In_progress';
          this.azureValidationRemark = this.updateInspectionData.azureValidationRemark;
          this.updateInspectionData.isStockAdjustmentSuccess = this.updateInspectionData.isStockAdjustmentSuccess;
        //  if(this.azureStatus.toLowerCase() === 'in_progress'){
        //     this.showReload = true;
        //   }
        //     else{
        //     this.showReload = false;
        //   }
        }
        this.checkValiationTimeout();
        console.log('shipment Inspection details in update modal', this.updateInspectionData);
      }
      else {
        this.enableLoader = false;
        this.translationService.translate('shipment.emptyerrormessage').subscribe(res => {
          if (!toastshown) {
            this.toastrService.show(res);
            toastshown = true;
          }
        })
      }
    }, err => {
      this.enableLoader = false;
      this.translationService.translate('shipment.erroroccuredmessage').subscribe(res => {
        if (!toastshown) {
          this.toastrService.show(res);
          toastshown = true;
        }
      })
    })
  }
  get isUpdateFormFilled(): boolean {
    const draftSurveyQty = this.updateForm?.get('draftSurveyQty')?.value;
    const surveyStartDate = this.updateForm?.get('surveyStartDate')?.value;
    const surveyEndDate = this.updateForm?.get('surveyEndDate')?.value;
    const inspectionCompleted = this.updateForm?.get('inspectionCompleted')?.value;
    const hasAtLeastOneDocument = this.fileArray?.length > 0;

    return inspectionCompleted === 'yes' &&
      draftSurveyQty !== null &&
      draftSurveyQty !== undefined &&
      `${draftSurveyQty}`.trim() !== '' &&
      !!surveyStartDate &&
      !!surveyEndDate &&
      hasAtLeastOneDocument;
  }

}

